const curriculum = {
  // HeroSection
  'curriculum.hero.homeLink': 'ホーム',
  'curriculum.hero.aboutLink': 'アカデミーについて',
  'curriculum.hero.currentPage': 'カリキュラム概要',
  'curriculum.hero.title': 'カリキュラム概要',
  'curriculum.hero.titleEn': 'CURRICULUM',
  'curriculum.hero.lead': '当アカデミーのカリキュラムは、理論と実践を往復しながら段階的に技能を積み上げます。座学・実技・ロールプレイング・評価の循環で、確かな力を育みます。執事・バトラー養成に求められる知識と所作を、少人数制の実践的な研修として体系立てて習得できるよう設計しています。執事を体系的に学べる執事学校として、エッセンシャルからマスターまで学びの期間に応じた課程を用意しています。',
  'curriculum.hero.imgAlt': '講義室でホワイトボードを使い執事の所作を説明する講師と受講生',

  // LearningCycle
  'curriculum.cycle.label': 'HOW WE TEACH',
  'curriculum.cycle.title': '学びの全体像',
  'curriculum.cycle.titleEn': 'Learning Cycle',
  'curriculum.cycle.description': '当アカデミーの学びは、聞いて終わりにはしません。理論で理解し、実技で試し、ロールプレイングで磨く——この往復を繰り返して技能を身につけます。各コースで難易度を段階的に上げながら、着実にプロフェッショナルへと導きます。執事・バトラーを育てる日本の執事学校として、この循環型の学びを軸に養成を進めています。',
  'curriculum.cycle.0.step': '01',
  'curriculum.cycle.0.title': '講義（理論）',
  'curriculum.cycle.0.titleEn': 'Lecture',
  'curriculum.cycle.0.description': '協会監修の教科書を用いて、執事の歴史・作法・ホスピタリティ理論を体系的に学びます。知識の土台を固める段階です。',
  'curriculum.cycle.1.step': '02',
  'curriculum.cycle.1.title': '実技（演習）',
  'curriculum.cycle.1.titleEn': 'Practice',
  'curriculum.cycle.1.description': '講義で学んだ内容を、少人数クラスで実際に手を動かして試します。テーブルセッティングからワインサービスまで、講師の指導のもと反復練習します。',
  'curriculum.cycle.2.step': '03',
  'curriculum.cycle.2.title': 'ロールプレイング',
  'curriculum.cycle.2.titleEn': 'Role-Play',
  'curriculum.cycle.2.description': '実際の邸宅やホテルを想定したスタジオで、リアルな場面を再現。受講生同士または講師とで役割を演じ、臨機応変な対応力を養います。',
  'curriculum.cycle.3.step': '04',
  'curriculum.cycle.3.title': '評価・フィードバック',
  'curriculum.cycle.3.titleEn': 'Evaluation',
  'curriculum.cycle.3.description': '講師が各人の所作・対応を細かく観察し、個別にフィードバック。改善点を明確にして次の学習につなげる、循環型の向上サイクルです。',

  // LearningCycle bottom note
  'curriculum.cycle.note': 'この循環をコースごとに繰り返しながら、難易度を段階的に引き上げていきます。',
  'curriculum.cycle.coursesLink': 'コース一覧・比較',

  // FourPillars
  'curriculum.pillars.label': 'FOUR PILLARS',
  'curriculum.pillars.title': 'カリキュラムの4つの柱',
  'curriculum.pillars.titleEn': 'Four Pillars',
  'curriculum.pillars.description': 'カリキュラムは四つの柱で構成されています。実践トレーニング、体系的な教材、習得スキルの明確化、そして進捗の評価です。それぞれが有機的につながり、総合力を育みます。執事・バトラー養成の体系を、この四つの柱で支えています。',
  'curriculum.pillars.viewLink': '詳しく見る',
  'curriculum.pillars.0.title': '実践トレーニング',
  'curriculum.pillars.0.titleEn': 'Practical Training',
  'curriculum.pillars.0.description': '実技とロールプレイングを中心とした少人数制の訓練。スタジオでの本格的な環境で、即戦力となる実践力を磨きます。',
  'curriculum.pillars.1.title': '使用教材',
  'curriculum.pillars.1.titleEn': 'Textbooks & Materials',
  'curriculum.pillars.1.description': '一般社団法人全日本執事協会が監修する全15冊の専門教科書(基礎・応用・専門の各5冊)。講義と自習の両方で活用し、修了後も参考資料として役立ちます。',
  'curriculum.pillars.2.title': '習得スキル一覧',
  'curriculum.pillars.2.titleEn': 'Skill Map',
  'curriculum.pillars.2.description': '基礎知識・実践スキル・コミュニケーション・問題解決・国際感覚の5領域で、段階的に習得する全スキルを一覧化しています。',
  'curriculum.pillars.3.title': '評価・進捗管理',
  'curriculum.pillars.3.titleEn': 'Assessment & Progress',
  'curriculum.pillars.3.description': '各実習ごとの講師評価と自己評価を組み合わせ、強みと課題を可視化。段階的な成長を支える進捗管理を行います。',

  // FourPillars evaluation note
  'curriculum.pillars.evalNote.title': '評価・進捗管理について',
  'curriculum.pillars.evalNote.text': '評価・進捗管理の詳細ページは準備中です。現在は各コース内で、実習ごとに講師が個別フィードバックを行い、受講生の成長を段階的にサポートしています。専用ページが完成次第、当サイトにて順次公開いたします。',
  'curriculum.pillars.tableHeader': '項目',

  // CourseGoals
  'curriculum.goals.label': 'COURSE GOALS',
  'curriculum.goals.title': 'コース別の到達目標',
  'curriculum.goals.titleEn': 'Course Goals by Level',
  'curriculum.goals.description': '以下は各コース修了時点での到達目標の目安です。コースが進むにつれて、より高度な知識と実践力を段階的に身につけます。',
  'curriculum.goals.note': '※これは到達目標であり、修了を保証する実績値ではありません。',
  'curriculum.goals.perspective.0': '基礎知識',
  'curriculum.goals.perspective.1': '実践スキル',
  'curriculum.goals.perspective.2': 'コミュニケーション',
  'curriculum.goals.perspective.3': '問題解決',
  'curriculum.goals.perspective.4': '国際感覚',

  // CourseGoals levels and perspectives
  'curriculum.goals.tableHeader': '項目',
  'curriculum.goals.coursesLink': 'コース一覧・比較を見る',
  'curriculum.goals.level.0.course': 'エッセンシャル',
  'curriculum.goals.level.0.courseEn': 'ESSENTIAL',
  'curriculum.goals.level.1.course': 'アドバンス',
  'curriculum.goals.level.1.courseEn': 'ADVANCED',
  'curriculum.goals.level.2.course': 'マスター',
  'curriculum.goals.level.2.courseEn': 'MASTER',
  'curriculum.goals.perspective.0.label': '基礎知識',
  'curriculum.goals.perspective.0.desc': '執事の歴史、作法、ホスピタリティ理論の理解度',
  'curriculum.goals.perspective.1.label': '実践スキル',
  'curriculum.goals.perspective.1.desc': 'テーブルサービス、衣類管理、ワイン知識などの実践力',
  'curriculum.goals.perspective.2.label': 'コミュニケーション',
  'curriculum.goals.perspective.2.desc': '来客応対、状況判断、言葉遣い・所作を含む総合的な対人能力',
  'curriculum.goals.perspective.3.label': '問題解決',
  'curriculum.goals.perspective.3.desc': '予期せぬ事態への対応、危機管理、柔軟な判断力',
  'curriculum.goals.perspective.4.label': '国際感覚',
  'curriculum.goals.perspective.4.desc': '異文化理解、英語対応、国際的なマナーとプロトコル',

  // Textbooks
  'curriculum.textbooks.label': 'TEXTBOOKS',
  'curriculum.textbooks.title': '教材の体系',
  'curriculum.textbooks.titleEn': 'Textbook System',
  'curriculum.textbooks.description': '一般社団法人全日本執事協会が監修する全15冊の専門教科書群(基礎のE群・応用のA群・専門のM群、各5冊)。コースによって使用する冊数が異なり、段階的に知識を深めていきます。詳細は使用教材ページをご覧ください。',
  'curriculum.textbooks.viewMaterials': '使用教材を見る',
  'curriculum.textbooks.groups.0.title': 'E群 基礎教科書（全コース共通・5冊）',
  'curriculum.textbooks.groups.0.note': '全コース共通で提供',
  'curriculum.textbooks.groups.1.title': 'A群 応用教科書（アドバンス・マスター・5冊）',
  'curriculum.textbooks.groups.1.note': 'アドバンスはE群5冊も提供（計10冊）',
  'curriculum.textbooks.groups.2.title': 'M群 専門教科書（マスター限定・5冊）',
  'curriculum.textbooks.groups.2.note': 'マスターは全15冊を提供',
  'curriculum.textbooks.groups.0.books.0.code': 'E1',
  'curriculum.textbooks.groups.0.books.0.title': '『E1 執事学入門：歴史・文化・職業倫理』',
  'curriculum.textbooks.groups.0.books.0.description': '英国発祥の執事文化の歴史から現代に至るまでの変遷、執事としての職業倫理と心構えを学ぶ入門書。全コース共通の基本テキストです。',
  'curriculum.textbooks.groups.0.books.0.courses': '全コース共通',
  'curriculum.textbooks.groups.0.books.1.code': 'E2',
  'curriculum.textbooks.groups.0.books.1.title': '『E2 ハウスキーピングの理論と実践』',
  'curriculum.textbooks.groups.0.books.1.description': '邸宅の清掃・洗濯・衣類管理から家政運営の基礎理論まで、ハウスキーピングの実務を体系的に学ぶ一冊です。',
  'curriculum.textbooks.groups.0.books.1.courses': '全コース共通',
  'curriculum.textbooks.groups.0.books.2.code': 'E3',
  'curriculum.textbooks.groups.0.books.2.title': '『E3 サービスの基本とおもてなしの心』',
  'curriculum.textbooks.groups.0.books.2.description': 'テーブルマナー、来客応対、おもてなしの精神を軸に、サービスの基本所作を身につける実践テキストです。',
  'curriculum.textbooks.groups.0.books.2.courses': '全コース共通',
  'curriculum.textbooks.groups.0.books.3.code': 'E4',
  'curriculum.textbooks.groups.0.books.3.title': '『E4 コミュニケーションとビジネスマナー』',
  'curriculum.textbooks.groups.0.books.3.description': '敬語・言葉遣いから電話応対、ビジネス文書まで、執事に求められる対人スキルとマナーを網羅します。',
  'curriculum.textbooks.groups.0.books.3.courses': '全コース共通',
  'curriculum.textbooks.groups.0.books.4.code': 'E5',
  'curriculum.textbooks.groups.0.books.4.title': '『E5 英国紳士の教養とたしなみ』',
  'curriculum.textbooks.groups.0.books.4.description': '英国紳士文化に根差した教養、身だしなみ、会話術など、品格あるたしなみを学ぶ一冊です。',
  'curriculum.textbooks.groups.0.books.4.courses': '全コース共通',
  'curriculum.textbooks.groups.1.books.0.code': 'A1',
  'curriculum.textbooks.groups.1.books.0.title': '『A1 家政管理と財務運営』',
  'curriculum.textbooks.groups.1.books.0.description': '家計簿・予算管理から外部業者との折衝まで、邸宅運営における財務・家政管理の実務を学びます。',
  'curriculum.textbooks.groups.1.books.0.courses': 'アドバンス・マスター',
  'curriculum.textbooks.groups.1.books.1.code': 'A2',
  'curriculum.textbooks.groups.1.books.1.title': '『A2 ビジネスサポートと秘書業務』',
  'curriculum.textbooks.groups.1.books.1.description': 'スケジュール管理、文書作成、来客対応など、雇主のビジネスを支える秘書的実務を体系化しています。',
  'curriculum.textbooks.groups.1.books.1.courses': 'アドバンス・マスター',
  'curriculum.textbooks.groups.1.books.2.code': 'A3',
  'curriculum.textbooks.groups.1.books.2.title': '『A3 食事サービスとテーブルマナー』',
  'curriculum.textbooks.groups.1.books.2.description': 'フォーマルディナーの提供手順、ワイン・ティーサービス、テーブルコーディネートを学ぶ実践書です。',
  'curriculum.textbooks.groups.1.books.2.courses': 'アドバンス・マスター',
  'curriculum.textbooks.groups.1.books.3.code': 'A4',
  'curriculum.textbooks.groups.1.books.3.title': '『A4 イベント企画と空間演出』',
  'curriculum.textbooks.groups.1.books.3.description': 'パーティーやレセプションの企画運営、空間演出、装花・照明までを扱う応用テキストです。',
  'curriculum.textbooks.groups.1.books.3.courses': 'アドバンス・マスター',
  'curriculum.textbooks.groups.1.books.4.code': 'A5',
  'curriculum.textbooks.groups.1.books.4.title': '『A5 ライフスタイル管理と特別サポート』',
  'curriculum.textbooks.groups.1.books.4.description': '雇主の日常生活全般のマネジメントと、個別ニーズに応じた特別なサポート技術を学びます。',
  'curriculum.textbooks.groups.1.books.4.courses': 'アドバンス・マスター',
  'curriculum.textbooks.groups.2.books.0.code': 'M1',
  'curriculum.textbooks.groups.2.books.0.title': '『M1 国際プロトコルと各国文化』',
  'curriculum.textbooks.groups.2.books.0.description': '各国の外交儀礼・文化的タブー・国際的なマナーを収録し、グローバルに活躍する知識を提供します。',
  'curriculum.textbooks.groups.2.books.0.courses': 'マスター',
  'curriculum.textbooks.groups.2.books.1.code': 'M2',
  'curriculum.textbooks.groups.2.books.1.title': '『M2 社交技術とエスコート』',
  'curriculum.textbooks.groups.2.books.1.description': '社交の場でのふるまい、エスコート技術、会話術など、上級執事に求められる社交スキルを学びます。',
  'curriculum.textbooks.groups.2.books.1.courses': 'マスター',
  'curriculum.textbooks.groups.2.books.2.code': 'M3',
  'curriculum.textbooks.groups.2.books.2.title': '『M3 トラベルサポートと移動管理』',
  'curriculum.textbooks.groups.2.books.2.description': '旅程の手配から車両・移動手段の管理まで、雇主の移動を支えるトラベルサポートの実務を学びます。',
  'curriculum.textbooks.groups.2.books.2.courses': 'マスター',
  'curriculum.textbooks.groups.2.books.3.code': 'M4',
  'curriculum.textbooks.groups.2.books.3.title': '『M4 危機管理とトラブル対応』',
  'curriculum.textbooks.groups.2.books.3.description': '医療緊急時、自然災害、セキュリティ事案など、邸宅で起こりうる危機への対応力を養います。',
  'curriculum.textbooks.groups.2.books.3.courses': 'マスター',
  'curriculum.textbooks.groups.2.books.4.code': 'M5',
  'curriculum.textbooks.groups.2.books.4.title': '『M5 VVIPサービスとマネジメント』',
  'curriculum.textbooks.groups.2.books.4.description': '最上級の顧客層に向けたサービス設計とスタッフマネジメント、執事としての総合力を極める最終巻です。',
  'curriculum.textbooks.groups.2.books.4.courses': 'マスター',

  // FAQSection
  'curriculum.faq.label': 'FAQ',
  'curriculum.faq.title': 'よくあるご質問',
  'curriculum.faq.titleEn': 'Frequently Asked Questions',
  'curriculum.faq.footer': 'その他のご質問は',
  'curriculum.faq.footerSuffix': 'よりお寄せください',
  'curriculum.faq.0.question': '座学だけですか？',
  'curriculum.faq.0.answer': 'いいえ。講義で学んだ内容を必ず実技とロールプレイングで実践し、講師のフィードバックで仕上げる循環型のカリキュラムです。',
  'curriculum.faq.1.question': '教材はありますか？',
  'curriculum.faq.1.answer': '協会監修の教科書を使用します。コースにより使用する冊数が異なり、卒業後の参考資料としても活用できます。',
  'curriculum.faq.2.question': 'どんなスキルが身につきますか？',
  'curriculum.faq.2.answer': '基礎の所作からテーブルサービス、ワイン、危機対応、管理能力まで段階的に習得します。詳しくは習得スキル一覧をご覧ください。',
  'curriculum.faq.3.question': '授業はどのような日程・形式で行われますか？',
  'curriculum.faq.3.answer': '土日開催で、1日6時間（90分×4コマ）の対面授業を行います。対面授業に加えて、予習・復習用のオンデマンド動画講座を組み合わせたハイブリッド形式を採用しており、対面の時間は実技とロールプレイングに集中できます。お仕事を続けながら計画的に学べる日程です。',
  'curriculum.faq.4.question': '1クラスは何名ですか？少人数で学べますか？',
  'curriculum.faq.4.answer': '完全少人数制で、1クラスの定員は最大6名（最少催行3名）です。講師が受講生一人ひとりの所作や対応を細部まで確認し、その場で個別にフィードバックできる規模にとどめています。少人数だからこそ、執事・バトラーに求められる所作を丁寧に身につけられます。',
  'curriculum.faq.5.question': '修了の要件や試験について教えてください。',
  'curriculum.faq.5.answer': '修了には出席率80%以上が必要です。各コースの修了時には筆記試験（30分）と実技試験を実施し、合格者には一般社団法人全日本執事協会の認定資格を授与します。実技試験に不合格の場合も、1回まで無料で再試験を受けていただけます。',
  'curriculum.faq.6.question': '実際のサービスを体験する機会はありますか？',
  'curriculum.faq.6.answer': 'アドバンスコース・マスターコースでは、受講生自身が顧客として一流ホテルのディナーやアフタヌーンティーを体験し、プロフェッショナルの所作を間近で観察・学習する実習を設けています。座学と実技で学んだ内容を、本物の現場感覚と結びつけて深めていきます。',

  // FAQSection inline footer
  'curriculum.faq.footerContact': 'お問い合わせ',

  // TextbookSystem link
  'curriculum.textbooks.detailLink': '使用教材の詳細を見る',

  // CTASection
  'curriculum.cta.label': 'NEXT STEP',
  'curriculum.cta.title': 'さらに詳しく知る',
  'curriculum.cta.body': 'カリキュラムの各要素について、専用の詳細ページをご用意しています。コース選びに迷われる方は、個別相談もご活用ください。',
  'curriculum.cta.training': '実践トレーニングを見る',
  'curriculum.cta.materials': '使用教材を見る',
  'curriculum.cta.courses': 'コース一覧を見る',

  // RelatedPages
  'curriculum.related.label': 'LEARN MORE',
  'curriculum.related.title': '関連ページ',
  'curriculum.related.titleEn': 'Explore Further',
  'curriculum.related.viewLink': '詳しく見る',
  'curriculum.related.0.title': '実践トレーニング',
  'curriculum.related.0.desc': '実技とロールプレイング中心の訓練',
  'curriculum.related.1.title': '使用教材',
  'curriculum.related.1.desc': '協会監修の教科書全15冊',
  'curriculum.related.2.title': '習得スキル一覧',
  'curriculum.related.2.desc': '身につく5つのスキル領域',
  'curriculum.related.3.title': 'コース一覧・比較',
  'curriculum.related.3.desc': '3コースの違いを一覧で確認',
  'curriculum.related.4.title': '教育理念・方針',
  'curriculum.related.4.desc': '私たちが大切にする教育の考え方',

  // Last updated
  'curriculum.lastUpdated': '最終更新: 2026年7月8日',
};

export default curriculum;
